import React, { useCallback, useRef, useState } from 'react'

const Searchbar = ({ setQueriedLabel }) => {
  const inputRef = useRef()
  const [query, setQuery] = useState('')

  const handleChange = useCallback((e) => {
    setQuery(e.target.value)
    setQueriedLabel(e.target.value)
  }, [])

  return (
    <div className='searchbar search-fields'>
      <div><i className='fa-light fa-sm fa-magnifying-glass'></i></div>
      <input ref={inputRef} type='text' onChange={handleChange} value={query} placeholder='search fields...' />
    </div>
  )
}

export default Searchbar
